// extracted by mini-css-extract-plugin
export default {"root":"_2Z00S","small":"_3tGRL","normal":"SabwD"};